module.exports = __webpack_public_path__ + "img/850-031d38.png";